// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3EubZ","name":"Header_name__1cYru","birthday":"Header_birthday__30fsu","skeleton":"Header_skeleton__1BVYM"};